import { Address, fromNano, TupleReader } from "@ton/core";
import { JettonMaster } from "@ton/ton";
import { action, flow, flowResult, makeObservable, observable } from "mobx";
// import { tokensList } from "../../components/PlaceARaffle/PlaceARaffleLaunch/PlaceARaffleLaunch";
import { Ticker } from "../../entities/Ticker/TickerTypes";
import { JettonWallet } from "../../lib/wrappers/JettonWallet";
import { tokenList } from "../../utils/AppConstants";
import raceGuard from "../../utils/raceGuard";
import BusyStore from "../common/BusyStore";
import TonClientStore from "../TonClientStore/TonClientStore";

class WalletStore extends BusyStore {
  userAddress: string | undefined;
  tonBalance: string | undefined;
  usdtBalance: string | undefined;
  raffBalance: string | undefined;
  isWalletV5AndMore: boolean | undefined = undefined;
  constructor(private readonly tonClientStore: TonClientStore) {
    super();
    makeObservable<
      WalletStore,
      "loadTonBallanceFlow" | "loadJettonBallanceFlow"
    >(this, {
      userAddress: observable,
      tonBalance: observable,
      usdtBalance: observable,
      raffBalance: observable,
      isWalletV5AndMore: observable,

      setUserAddress: action,

      loadTonBallanceFlow: flow,
      loadJettonBallanceFlow: flow,
    });
  }

  setUserAddress = (address: string | undefined) => {
    this.userAddress = address;
  };

  readonly loadTonBallance = raceGuard(
    async () => await flowResult(this.loadTonBallanceFlow())
  );

  readonly loadUsdtBallance = raceGuard(
    async () => await flowResult(this.loadJettonBallanceFlow(Ticker.USDT))
  );

  readonly loadRaffBallance = raceGuard(
    async () => await flowResult(this.loadJettonBallanceFlow(Ticker.RAFF))
  );

  private *loadTonBallanceFlow() {
    this.onLoadingStart();
    try {
      if (this.userAddress && this.tonClientStore.tonClient) {
        const value: bigint = yield this.tonClientStore.tonClient.getBalance(
          Address.parse(this.userAddress)
        );
        this.tonBalance = fromNano(value);
        try {
          const result: {
            gas_used: number;
            stack: TupleReader;
          } = yield this.tonClientStore.tonClient.runMethod(
            Address.parse(this.userAddress),
            "is_signature_allowed"
          );
          console.log(result);
          this.isWalletV5AndMore = true;
        } catch (_) {
          this.isWalletV5AndMore = false;
        }
        return this.tonBalance;
      }
    } catch (_) {
      if (this.tonClientStore.tonClient4 && this.userAddress) {
        const seqno: number = yield this.tonClientStore.tonClient4
          .getLastBlock()
          .then((last) => last.last.seqno);
        try {
          const result: {
            exitCode: number;
          } = yield this.tonClientStore.tonClient4.runMethod(
            seqno,
            Address.parse(this.userAddress),
            "is_signature_allowed"
          );

          this.isWalletV5AndMore = result.exitCode === 0;
        } catch (_) {
          this.isWalletV5AndMore = false;
        }
      }
    } finally {
      this.onLoadingFinished();
    }
  }

  private *loadJettonBallanceFlow(current: Ticker) {
    this.onLoadingStart();
    const jettonMasterAddressString = tokenList.filter(
      (item) => item.value === current
    );
    const jettonMasterAddress = Address.parse(
      jettonMasterAddressString[0].address
    );
    try {
      if (this.userAddress && this.tonClientStore.tonClient4) {
        const jettonMaster = this.tonClientStore.tonClient4.open(
          JettonMaster.create(jettonMasterAddress)
        );
        const jettonWallet = this.tonClientStore.tonClient4.open(
          JettonWallet.createFromAddress(
            yield jettonMaster.getWalletAddress(Address.parse(this.userAddress))
          )
        );
        const value: bigint = yield jettonWallet.getJettonBalance();

        if (current === Ticker.USDT) {
          this.usdtBalance = (
            parseFloat(fromNano(value)) * Math.pow(10, 3)
          ).toString();
        } else if (current === Ticker.RAFF) {
          this.raffBalance = fromNano(value);
        }
      }
    } catch (error) {
      console.log(error);
      if (this.userAddress && this.tonClientStore.tonClient) {
        const jettonMaster = this.tonClientStore.tonClient.open(
          JettonMaster.create(jettonMasterAddress)
        );
        const jettonWallet = this.tonClientStore.tonClient.open(
          JettonWallet.createFromAddress(
            yield jettonMaster.getWalletAddress(Address.parse(this.userAddress))
          )
        );
        const value: bigint = yield jettonWallet.getJettonBalance();
        if (current === Ticker.USDT) {
          this.usdtBalance = (
            parseFloat(fromNano(value)) * Math.pow(10, 3)
          ).toString();
        } else if (current === Ticker.RAFF) {
          this.raffBalance = fromNano(value);
        }
      }
    } finally {
      this.onLoadingFinished();
    }
  }
}

export default WalletStore;
